import styled from '@emotion/styled'

import type { FC } from 'react'
import { useMemo } from 'react'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import EmailCaptureForm from '@segment/templates/Forms/EmailCaptureForm'

import type { Answers, Result } from '../../calculateResults'
import calculateResults, { formatTrackingResults } from '../../calculateResults'

const copy = {
  heading: `Calculate your results`,
  description: `Enter your email so we can send your results. We’ll show you the results right away and send you the copy.`,
  button: `Send results`,
}

interface CalculateResultsProps {
  onSubmit: (result: Result) => void
  answers: string[]
}

const CalculateResults: FC<CalculateResultsProps> = ({ onSubmit, answers }) => {
  const result = useMemo(() => {
    return calculateResults(answers as Answers[])
  }, [answers])
  return (
    <Wrapper>
      <StyledSection variant="centered">
        <Section.Copy>
          <Copy centered={true}>
            <CopyText.Heading>{copy.heading}</CopyText.Heading>
            <CopyText.Description>{copy.description}</CopyText.Description>
          </Copy>

          <FormWrapper>
            <EmailCaptureForm
              compact={true}
              buttonText={copy.button}
              success={null}
              onSubmit={() => onSubmit(result)}
              customFormIdentifier="cdm-quiz"
              customData={{ customTrackData: formatTrackingResults(result) }}
            />
          </FormWrapper>
        </Section.Copy>
      </StyledSection>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
  }
`

const Copy = styled(CopyTextBase)`
  max-width: 680px;
`

const FormWrapper = styled.div`
  max-width: 420px;
  margin: 30px 0;
`

export default CalculateResults
